import PickGenres from "@components/Onboarding/PickGenres";

export default PickGenres;
